import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const Gracias = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const origen = searchParams.get('origen');
  
  const getContent = () => {
    if (origen === 'contacto') {
      return {
        title: '¡Mensaje Recibido con Éxito!',
        message: 'Gracias por escribirnos. Un ingeniero especialista de Fieldstech revisará tu solicitud y se pondrá en contacto contigo en menos de 24 horas hábiles.'
      };
    } else if (origen === 'diagnostico') {
      return {
        title: '¡Solicitud de Diagnóstico Recibida!',
        message: 'Hemos recibido la información de tu sistema. Nuestro equipo de arquitectura cloud preparará tu evaluación técnica preliminar y te contactará a la brevedad.'
      };
    } else {
      return {
        title: '¡Gracias por contactarnos!',
        message: 'Hemos recibido tu solicitud. Te responderemos a la brevedad posible.'
      };
    }
  };
  
  const content = getContent();

  return (
    <div className="min-h-screen bg-slate-50 pt-24 sm:pt-28">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-16 sm:py-20 lg:py-24">
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 lg:p-16 text-center">
          {/* Icon */}
          <div className="w-20 h-20 sm:w-24 sm:h-24 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6 sm:mb-8">
            <CheckCircle className="w-10 h-10 sm:w-12 sm:h-12 text-emerald-500" strokeWidth={2} />
          </div>
          
          {/* Title */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            {content.title}
          </h1>
          
          {/* Message */}
          <p className="text-lg sm:text-xl text-gray-600 mb-8 sm:mb-10 leading-relaxed max-w-2xl mx-auto">
            {content.message}
          </p>
          
          {/* Button */}
          <Button
            onClick={() => navigate('/')}
            className="bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-8 py-3 sm:px-10 sm:py-4 text-base sm:text-lg rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
          >
            Volver al inicio
          </Button>
          
          {/* Optional note */}
          <p className="mt-8 sm:mt-10 text-sm text-gray-500">
            Mientras tanto, descubre más sobre{' '}
            <button
              onClick={() => navigate('/#servicios')}
              className="text-emerald-500 hover:text-emerald-600 underline transition-colors"
            >
              nuestros servicios
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Gracias;
